import { HGEOwesReport, HGEOwesReportItem } from "../../../models";

export const getHGEOwesReport = (data: any): HGEOwesReport => {
  return {
    invoices: data.invoices.map(getHGEOwesReportItem),
  };
};

const getHGEOwesReportItem = (data: any): HGEOwesReportItem => {
  return {
    invoiceId: data.invoice_id,
    orderId: data.order_id,
    name: data.name,
    total: data.total,
    type: data.type,
    date: data.date,
    address: data.address,
  };
};
